import React, { Component } from "react";
import CartContext from "./CartContext";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { OrderDetails } from "./OrderDetails";
import { SideMenu } from "./SideMenu";
import { BiSave, BiRefresh, BiUpload, BiDownload } from "react-icons/bi";
import { OrderHistory } from "./OrderHistory";
import { Navigate } from "react-router-dom";
import { LoadSpinner } from "./LoadSpinner";

import {
  InputGroup,
  Stack,
  FormControl,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

import Select from "react-select";
import {} from "react-bootstrap";

export class PurchaseByRawMaterialReport extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
  };

  GetPurchasesByRawMaterial = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetPurchasesByRawMaterial/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ result: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
        // alert("GetOrders fetch err:" + error);
      });
  };
  DownloadToCSV = () => {
    var headings =
      "#,Product Name,Tot.Qty,Purchases in Amount,Tax Amount,Total ";
    var reportDetails = "RawMaterials Purchase by Material Summary  - Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate
    );
    var rows = "";
    this.state.result
      .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
      .map((m, i) => {
        rows +=
          i +
          1 +
          "," +
          m.name +
          "," +
          m.totqty +
          "," +
          Number(m.price).toFixed(2) +
          "," +
          Number((m.price * m.tax) / 100).toFixed(2) +
          "," +
          Number(m.price + (m.price * m.tax) / 100).toFixed(2);

        rows += "\n";
      });

    var result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };
  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };
  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  GetLabelOfProduct = (id) => {
    var prods = this.props.rawMaterialsInventory.filter((f) => f.id == id);
    if (prods.length > 0)
      return prods[0].name + " " + prods[0].weight + prods[0].unit;
    return "";
  };

  componentDidMount = () => {
    //this.GetPurchasesByProduct();
  };

  render() {
    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td>
                  <Button onClick={(e) => this.GetPurchasesByRawMaterial()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                  {this.state.dateRange == "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>
                  <Button onClick={(e) => this.GetPurchasesByRawMaterial()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          )}
          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <th className="text-center">No.</th>
              <th className="text-start">Product Name</th>
              <th>Tot.Qty</th>
              <th>
                Purchases in Amount
                <br />[
                {this.state.result
                  .reduce((a, v) => (a = a + Number(v.price)), 0)
                  .toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                ]
              </th>
              <th>
                Tax Amount
                <br />[
                {this.state.result
                  .reduce((a, v) => (a = a + Number(v.price * v.tax) / 100), 0)
                  .toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                ]
              </th>
              <th>
                Total
                <br />[
                {this.state.result
                  .reduce(
                    (a, v) => (a = a + v.price + Number(v.price * v.tax) / 100),
                    0
                  )
                  .toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                ]
              </th>
            </thead>
            <tbody>
              {this.state.result
                .sort((a, b) => (a.totqty < b.totqty ? 1 : -1))
                .map((m, i) => (
                  <>
                    <tr>
                      <td className="text-center">{i + 1}</td>
                      <td className="text-start">
                        {this.GetLabelOfProduct(m.name)}
                      </td>
                      <td>{Number(m.totqty).toFixed(1)}</td>
                      <td>
                        {m.price.toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          }
                        )}
                      </td>
                      <td>
                        {Number((m.price * m.tax) / 100).toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          }
                        )}
                      </td>
                      <td>
                        {(m.price + (m.price * m.tax) / 100).toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          }
                        )}
                      </td>
                    </tr>
                  </>
                ))}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}
export class RawMaterialsPurchaseOrderSummaryReport extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
  };

  GetRawMaterialPurchaseSummaryReport = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetRawMaterialPurchaseSummaryReport/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ result: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
        // alert("GetOrders fetch err:" + error);
      });
  };

  DownloadToCSV = () => {
    var headings =
      "#,CreatedOn,InvoiceNo, Tot.Purchase Amount,Tot.Purchsed Items ";
    var reportDetails = "RawMaterials Purchase Order(PO) Summary  - Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate
    );
    var rows = "";
    this.state.result
      .sort((a, b) => (a.created < b.created ? 1 : -1))
      .map((m, i) => {
        rows +=
          i +
          1 +
          "," +
          this.context.GetInDateFormat(new Date(m.created)) +
          "," +
          m.invoiceNo +
          "," +
          Number(m.totAmount).toFixed(2) +
          "," +
          Number(m.totQty).toFixed(2);

        rows += "\n";
      });

    var result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download =
      "products-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };
  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };
  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  componentDidMount = () => {
    //this.GetPurchasesByProduct();
  };

  render() {
    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td>
                  <Button
                    onClick={(e) => this.GetRawMaterialPurchaseSummaryReport()}
                  >
                    Show Report
                  </Button>
                </td>
                <td className="">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                  {this.state.dateRange == "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>
                  <Button
                    onClick={(e) => this.GetRawMaterialPurchaseSummaryReport()}
                  >
                    Show Report
                  </Button>
                </td>
                <td className="">
                  {this.state.result.length > 0 ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          )}
          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <th className="text-center">No.</th>
              <th className="text-start">CreatedOn</th>
              <th className="text-start">InvoiceNo</th>
              <th>
                Tot.Purchase Amount
                <br />[
                {this.state.result
                  .reduce((a, v) => (a = a + Number(v.totAmount)), 0)
                  .toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                ]
              </th>
              <th>
                Tot.Purchsed Items
                <br />[
                {this.state.result.reduce(
                  (a, v) => (a = a + Number(v.totQty)),
                  0
                )}
                ]
              </th>
            </thead>
            <tbody>
              {this.state.result
                .sort((a, b) => (a.created < b.created ? 1 : -1))
                .map((m, i) => (
                  <>
                    <tr>
                      <td className="text-center">{i + 1}</td>
                      <td className="text-start">
                        {this.context.GetInDateFormat(new Date(m.created))}
                      </td>
                      <td className="text-start">{m.invoiceNo}</td>
                      <td>
                        {m.totAmount.toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1,
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                          }
                        )}
                      </td>
                      <td>{Number(m.totQty).toFixed(1)}</td>
                    </tr>
                  </>
                ))}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}

export class SalesAndPurchaseSummaryReport extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: { totSales: 0, totTax: 0, totOrders: 0 },
      productPurchaseResult: { totSales: 0, totTax: 0, totOrders: 0 },
      rawmaterialPurchaseResult: { totSales: 0, totTax: 0, totOrders: 0 },
      accountrevenues: "",
      accountexpenses: "",
      startDate: new Date(),
      endDate: new Date(),
      reportGenerated: false,
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.setState({ result: [] }, () => {});
    });
    this.setState({ reportGenerated: false });
  };

  GetReports = () => {
    this.GetSalesReport();
    this.GetProductPurchaseReport();
    this.GetRawMaterialPurchaseReport();
    this.GetAccountRevenues();
    this.GetAccountExpenses();
    this.setState({ reportGenerated: true });
  };

  GetSalesReport = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetSalesReport/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ result: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
      });
  };
  GetProductPurchaseReport = () => {
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetProductPurchaseReport/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ productPurchaseResult: data });
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("GetOrders fetch err:" + error);
      });
  };
  GetRawMaterialPurchaseReport = () => {
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetRawMaterialPurchaseReport/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ rawmaterialPurchaseResult: data });
      })
      .catch((error) => {
        console.error("There was an error!", error);
        // alert("GetOrders fetch err:" + error);
      });
  };
  GetAccountRevenues = () => {
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetAccountRevenuesReport/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ accountrevenues: data }, () => {});
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetAccountExpenses = () => {
    fetch(
      process.env.REACT_APP_API +
        "Reports/GetAccountExpenses/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ accountexpenses: data }, () => {});
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  DownloadToCSV = () => {
    var headings = "";
    var reportDetails = "Sales & Expenses Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate
    );
    var rows = "";

    rows =
      "Type,Total Orders,Net Amount, Taxable Value, Tax Amount, CGST, SGST\n";

    //1. Product Sales Report
    if (this.state.result) {
      rows +=
        "Product Sales," +
        this.state.result.totOrders +
        "," +
        Number(this.state.result.totSales + this.state.result.totTax) +
        "," +
        Number(this.state.result.totSales) +
        "," +
        Number(this.state.result.totTax) +
        "," +
        Number(this.state.result.totTax / 2) +
        "," +
        Number(this.state.result.totTax / 2) +
        "\n";
    }

    //2. Product Purchases Report
    if (this.state.productPurchaseResult != "") {
      rows +=
        "Product Purchases" +
        "," +
        this.state.productPurchaseResult.totOrders +
        "," +
        Number(
          this.state.productPurchaseResult.totSales +
            this.state.productPurchaseResult.totTax
        ) +
        "," +
        Number(this.state.productPurchaseResult.totSales) +
        "," +
        Number(this.state.productPurchaseResult.totTax) +
        "," +
        Number(this.state.productPurchaseResult.totTax / 2) +
        "," +
        Number(this.state.productPurchaseResult.totTax / 2) +
        "\n";
    }
    //3. product Purchase Report
    if (this.state.rawmaterialPurchaseResult != "") {
      rows +=
        "RawMaterial Purchases," +
        this.state.rawmaterialPurchaseResult.totOrders +
        "," +
        Number(
          this.state.rawmaterialPurchaseResult.totSales +
            this.state.rawmaterialPurchaseResult.totTax
        ) +
        "," +
        Number(this.state.rawmaterialPurchaseResult.totSales) +
        "," +
        Number(this.state.rawmaterialPurchaseResult.totTax) +
        "," +
        Number(this.state.rawmaterialPurchaseResult.totTax / 2) +
        "," +
        Number(this.state.rawmaterialPurchaseResult.totTax / 2) +
        "\n";
    }

    rows += "\n\n\n";
    rows += "SUMMARY\n";
    rows += "Details,Value\n";
    rows +=
      "Tot.Revenue with Taxes(A)," +
      Number(this.state.result.totSales + this.state.result.totTax) +
      "\n";
    rows +=
      "Tot.Expenses with Taxes(B)," +
      Number(
        this.state.productPurchaseResult.totSales +
          this.state.productPurchaseResult.totTax +
          this.state.rawmaterialPurchaseResult.totSales +
          this.state.rawmaterialPurchaseResult.totTax
      ) +
      "\n";
    rows +=
      "A-B," +
      Number(
        this.state.result.totSales +
          this.state.result.totTax -
          (this.state.productPurchaseResult.totSales +
            this.state.productPurchaseResult.totTax +
            this.state.rawmaterialPurchaseResult.totSales +
            this.state.rawmaterialPurchaseResult.totTax)
      ) +
      "\n";
    rows +=
      "Tot.Tax Paid towards Purchase(C)," +
      Number(
        this.state.productPurchaseResult.totTax +
          this.state.rawmaterialPurchaseResult.totTax
      ) +
      "\n";
    rows +=
      "Tot.Tax Received from Sales(D)," + Number(this.state.result.totTax);

    var result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download =
      "salesandexpensesreport-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  componentDidMount = () => {
    //this.GetSalesByProduct();
  };

  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };
  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  render() {
    return (
      <>
        <div>
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td>
                  <Button onClick={(e) => this.GetReports()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {this.state.reportGenerated == true ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>
                  {this.state.dateRange == "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>
                  <Button onClick={(e) => this.GetReports()}>
                    Show Report
                  </Button>
                </td>
                <td className="">
                  {this.state.reportGenerated == true ? (
                    <>
                      <Button
                        // className="mainthemecolor"
                        variant="danger"
                        onClick={() => this.DownloadToCSV()}
                      >
                        <BiDownload size="20"></BiDownload>
                        Download
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            </>
          )}

          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            <thead>
              <th className="text-center">Type</th>
              <th className="text-center">Total Orders</th>
              <th>Net Amount</th>
              <th>Taxable Value</th>
              <th>Tax Amount</th>
              <th>CGST</th>
              <th>SGST</th>
            </thead>
            <tbody>
              {this.state.reportGenerated == true ? (
                <>
                  {/* Sales Report */}
                  {this.state.result != "" ? (
                    <>
                      <tr>
                        <td className="text-center">Product Sales</td>
                        <td className="text-center">
                          {this.state.result.totOrders}
                        </td>
                        <td>
                          {Number(
                            this.state.result.totSales +
                              this.state.result.totTax
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(this.state.result.totSales).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(this.state.result.totTax).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(this.state.result.totTax / 2).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(this.state.result.totTax / 2).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                      </tr>
                    </>
                  ) : (
                    <></>
                  )}
                  {/* product Purchase Report */}
                  {this.state.productPurchaseResult != "" ? (
                    <>
                      <tr>
                        <td className="text-center">Product Purchases</td>
                        <td className="text-center">
                          {this.state.productPurchaseResult.totOrders}
                        </td>
                        <td>
                          {Number(
                            this.state.productPurchaseResult.totSales +
                              this.state.productPurchaseResult.totTax
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.productPurchaseResult.totSales
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.productPurchaseResult.totTax
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.productPurchaseResult.totTax / 2
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.productPurchaseResult.totTax / 2
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                      </tr>
                    </>
                  ) : (
                    <></>
                  )}
                  {/* product Purchase Report */}
                  {this.state.rawmaterialPurchaseResult != "" ? (
                    <>
                      <tr>
                        <td className="text-center">RawMaterial Purchases</td>
                        <td className="text-center">
                          {this.state.rawmaterialPurchaseResult.totOrders}
                        </td>
                        <td>
                          {Number(
                            this.state.rawmaterialPurchaseResult.totSales +
                              this.state.rawmaterialPurchaseResult.totTax
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.rawmaterialPurchaseResult.totSales
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.rawmaterialPurchaseResult.totTax
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.rawmaterialPurchaseResult.totTax / 2
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.rawmaterialPurchaseResult.totTax / 2
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                      </tr>
                    </>
                  ) : (
                    <></>
                  )}
                  {/* Other Revenues Report */}
                  {this.state.accountrevenues != "" ? (
                    <>
                      <tr>
                        <td className="text-center">Other Revenues</td>
                        <td className="text-center">
                          {/* {this.state.accountrevenues.totOrders} */}0
                        </td>
                        <td>
                          {Number(
                            this.state.accountrevenues.total
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>
                          {Number(
                            this.state.accountrevenues.total
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
            </tbody>
          </Table>
          {this.state.reportGenerated == true ? (
            <>
              <div className="bg-white text-center p-5 mx-5">
                <div className="bg-white text-center p-5 mx-5">
                  <h2>Summary</h2>
                  <Table
                    bordered
                    striped
                    hover
                    className="bg-white text-start p-5 "
                    style={{
                      tableLayout: "revert",
                      verticalAlign: "middle",
                      fontFamily: "monospace",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    <thead
                      style={{
                        tableLayout: "revert",
                        verticalAlign: "middle",
                        fontFamily: "monospace",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      <th className="text-start" width="50%">
                        Details
                      </th>
                      <th className="text-end" width="50%">
                        Value
                      </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Tot.Revenue with Taxes(A) </td>
                        <td className="text-end">
                          {Number(
                            this.state.result.totSales +
                              this.state.result.totTax
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Tot.Expenses with Taxes(B)</td>
                        <td className="text-end">
                          {Number(
                            this.state.productPurchaseResult.totSales +
                              this.state.productPurchaseResult.totTax +
                              this.state.rawmaterialPurchaseResult.totSales +
                              this.state.rawmaterialPurchaseResult.totTax
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>A-B</td>
                        <td className="text-end">
                          {Number(
                            this.state.result.totSales +
                              this.state.result.totTax -
                              (this.state.productPurchaseResult.totSales +
                                this.state.productPurchaseResult.totTax +
                                this.state.rawmaterialPurchaseResult.totSales +
                                this.state.rawmaterialPurchaseResult.totTax)
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Tot.Tax Paid towards Purchase(C)</td>
                        <td className="text-end">
                          {Number(
                            this.state.productPurchaseResult.totTax +
                              this.state.rawmaterialPurchaseResult.totTax
                          ).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Tot.Tax Received from Sales(D)</td>
                        <td className="text-end">
                          {Number(this.state.result.totTax).toLocaleString(
                            this.context.storeSettings.defaultLocale,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                              style: "currency",
                              currency:
                                this.context.storeSettings.defaultCurrency,
                            }
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  }
}

export class SalesGstReport extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  OnDateRangeChanged = (e) => {
    const { value } = e.target;
    this.setState({ dateRange: value, result: [] });
  };

  GetSalesGst = async () => {
    try {
      this.ShowLoadSpinner();

      const storeId = this.context.storeId;
      if (!storeId) {
        console.warn("StoreId not available in context");
        this.setState({ result: [] });
        return;
      }

      const url = `${
        process.env.REACT_APP_API
      }Reports/GetSalesGst/${storeId}/${encodeURIComponent(
        this.state.dateRange
      )}/${this.context.GetTicks(this.state.startDate)}/${this.context.GetTicks(
        this.state.endDate
      )}`;

      const resp = await fetch(url);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const data = await resp.json();

      if (!Array.isArray(data)) {
        console.warn("Expected array from server", data);
        this.setState({ result: [] });
        return;
      }

      // Strict mapping to camelCase fields that backend returns
      const normalized = data.map((it) => ({
        billNo: it.billNo,
        date: it.date, // ISO string or null
        customerName: it.customerName,
        hsnCode: it.hsnCode,
        productName: it.productName,
        categoryName: it.category || it.categoryName,
        gstPercent: it.gstPercent,
        totalQty: Number.isFinite(Number(it.totalQty))
          ? Number(Number(it.totalQty).toFixed(2))
          : 0,
        salesAmount: Number.isFinite(Number(it.salesAmount))
          ? Number(Number(it.salesAmount).toFixed(2))
          : 0,
        taxAmount: Number.isFinite(Number(it.taxAmount))
          ? Number(Number(it.taxAmount).toFixed(2))
          : 0,
        // keep productId if backend returns it (used by getProductName)
        productId: it.productId ?? null,
      }));

      normalized.sort((a, b) => Number(a.billNo) - Number(b.billNo));
      this.setState({ result: normalized });
    } catch (err) {
      console.error("GetSalesGst failed", err);
      this.setState({ result: [] });
    } finally {
      this.HideLoadSpinner();
    }
  };

  DownloadToCSV = () => {
    const headings =
      "#,BillNo,Date,CustomerName,HSN,ProductName,Category,TotalQty,SalesAmount,TaxAmount";
    let reportDetails = "Sales (GST) Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate
    );

    let rows = "";
    (this.state.result || []).forEach((m, idx) => {
      const safe = (s) => String(s ?? "").replace(/[\r\n,]+/g, " ");
      const qty = Number(m.totalQty || 0).toFixed(2);
      const sales = Number(m.salesAmount || 0).toFixed(2);
      const tax = Number(m.taxAmount || 0).toFixed(2);

      rows += `${idx + 1},${safe(m.billNo)},${
        m.date ? new Date(m.date).toLocaleString() : ""
      },${safe(m.customerName)},${safe(m.hsnCode)},${safe(
        m.productName
      )},${safe(m.categoryName)},${qty},${sales},${tax}\n`;
    });

    const result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download =
      "sales-gst-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element); // Required for Firefox
    element.click();
    element.remove();
  };

  PrintReport = () => {
    const { result, dateRange, startDate, endDate } = this.state;
    const settings = this.context.storeSettings || {};

    if (!result || result.length === 0) return;

    const storeName = settings.storeName || "";
    const storeAddress = settings.storeAddress || "";
    const storeEmail = settings.storeEmailId || "";
    const storePhone = settings.storePhoneNo || "";

    const reportTitle = "Sales (GST) Report";
    const dateSection = this.context.GetDateResult(
      dateRange,
      startDate,
      endDate
    );

    // ----- Helpers -----
    const formatShortDate = (d) => {
      if (!d) return "";
      const dt = new Date(d);
      const dd = String(dt.getDate()).padStart(2, "0");
      const mm = String(dt.getMonth() + 1).padStart(2, "0");
      const yy = String(dt.getFullYear()).slice(-2);
      return `${dd}/${mm}/${yy}`;
    };

    const num2 = (n) => Number(n || 0).toFixed(2);

    // ----- Totals -----
    const salesTotal = result.reduce(
      (a, v) => a + Number(v.salesAmount || 0),
      0
    );
    const taxTotal = result.reduce((a, v) => a + Number(v.taxAmount || 0), 0);
    const invoiceTotal = salesTotal + taxTotal;

    // ----- HTML Build -----
    let html = `
  <html>
    <head>
      <title>${reportTitle}</title>
      <style>
        body { font-family: Arial; padding: 20px; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid #888; padding: 6px; font-size: 12px; }
        th { background: #f0f0f0; }
        th.text-start, td.text-start { text-align: left; }
        td { text-align: right; }
        h2, h4 { text-align: center; margin: 0; padding: 4px; }
        .store-header { text-align: center; margin-bottom: 10px; }
        .store-header .name { font-size: 20px; font-weight: bold; }
        .tot-row { font-weight: bold; background: #f3f3f3; }
      </style>
    </head>

    <body>
      <div class="store-header">
        <div class="name">${storeName}</div>
        <div>${storeAddress}</div>
        <div>${storeEmail ? "Email: " + storeEmail : ""} 
            ${storePhone ? " Phone: " + storePhone : ""}
        </div>
      </div>

      <h2>${reportTitle}</h2>
      <h4>${dateSection}</h4>

      <table>
        <thead>
          <tr>
            <th>No.</th>
            <th class="text-start">Bill No</th>
            <th class="text-start">Date</th>
            <th class="text-start">Customer</th>
            <th class="text-start">HSN</th>
            <th class="text-start">Product</th>
            <th class="text-start">Category</th>
            <th>Qty</th>
            <th>GST %</th>
            <th>Sales Amount</th>
            <th>Tax Amount</th>
            <th>Total Invoice Value</th>
          </tr>
        </thead>
        <tbody>
  `;

    // ----- Row rendering -----
    result.forEach((m, i) => {
      html += `
      <tr>
        <td>${i + 1}</td>
        <td class="text-start">${m.billNo || ""}</td>
        <td class="text-start">${formatShortDate(m.date)}</td>
        <td class="text-start">${m.customerName || ""}</td>
        <td class="text-start">${m.hsnCode || ""}</td>
        <td class="text-start">${m.productName || ""}</td>
        <td class="text-start">${m.categoryName || ""}</td>
        <td>${num2(m.totalQty)}</td>
        <td>${num2(m.gstPercent)}</td>
        <td>${num2(m.salesAmount)}</td>
        <td>${num2(m.taxAmount)}</td>
        <td>${num2(m.salesAmount + m.taxAmount)}</td>
      </tr>
    `;
    });

    // ----- Grand totals -----
    html += `
      <tr class="tot-row">
        <td colspan="9" style="text-align:right;">GRAND TOTAL →</td>
        <td>${num2(salesTotal)}</td>
        <td>${num2(taxTotal)}</td>
        <td>${num2(invoiceTotal)}</td>
      </tr>
    </tbody>
  </table>

  <script>
    window.onload = () => window.print();
  </script>

  </body>
  </html>
  `;

    const win = window.open("", "_blank");
    win.document.open();
    win.document.write(html);
    win.document.close();
  };

  componentDidMount = () => {
    // enable auto-load if needed:
    // this.GetSalesGst();
  };

  onStartDateChange = (date) => this.setState({ startDate: date });
  onEndDateChange = (date) => this.setState({ endDate: date });

  // product name lookup uses context.prods (keeps compatibility with other reports)
  getProductName = (row) => {
    if (!row) return "";
    if (row.productName && String(row.productName).trim() !== "")
      return row.productName;
    const prods = this.context.prods || [];
    const pid = row.productId || row.productID || row.productId;
    const found = prods.find(
      (p) =>
        p.id === pid ||
        String(p.id) === String(pid) ||
        p.productId === pid ||
        String(p.productId) === String(pid)
    );
    return found ? found.productName || found.name || "" : "";
  };

  formatCurrency = (value) => {
    const locale = this.context.storeSettings?.defaultLocale || "en-IN";
    const currency = this.context.storeSettings?.defaultCurrency || "INR";
    return Number(value || 0).toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      style: "currency",
      currency,
    });
  };

  render() {
    const { result } = this.state;
    const storeSettings = this.context.storeSettings || {};
    const currencyLocale = storeSettings.defaultLocale || "en-IN";

    const salesTotal = (result || []).reduce(
      (a, v) => a + Number(v.salesAmount || 0),
      0
    );
    const taxTotal = (result || []).reduce(
      (a, v) => a + Number(v.taxAmount || 0),
      0
    );

    return (
      <>
        <div>
          {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : null}

          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={this.OnDateRangeChanged}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                    </Form.Select>
                  </InputGroup>
                </td>

                {this.state.dateRange === "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : null}

                <td>
                  <Button onClick={() => this.GetSalesGst()}>
                    Show Report
                  </Button>
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button variant="success" onClick={this.PrintReport}>
                      🖨️ Print/PDF
                    </Button>
                  ) : null}
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button
                      variant="danger"
                      onClick={() => this.DownloadToCSV()}
                    >
                      <BiDownload size="20" /> Download(CSV)
                    </Button>
                  ) : null}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={this.OnDateRangeChanged}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>

                  {this.state.dateRange === "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : null}
                </td>

                <td>
                  <Button onClick={() => this.GetSalesGst()}>
                    Show Report
                  </Button>
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button
                      variant="danger"
                      onClick={() => this.DownloadToCSV()}
                    >
                      <BiDownload size="20" /> Download
                    </Button>
                  ) : null}
                </td>
              </tr>
            </>
          )}

          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th className="text-center">No.</th>
                <th className="text-start">Bill No</th>
                <th className="text-start">Date</th>
                <th className="text-start">Customer Name</th>
                <th className="text-start">HSN Code</th>
                <th className="text-start">Product Name</th>
                <th className="text-start">Category</th>
                <th>Total Qty</th>
                <th>GST %</th>
                <th>
                  Total Sales Amount
                  <br />[
                  {result && result.length > 0
                    ? salesTotal.toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th>
                <th>
                  Tax Amount
                  <br />[
                  {result && result.length > 0
                    ? taxTotal.toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th>
                <th>
                  Total Invoice Value
                  <br />[
                  {result && result.length > 0
                    ? (salesTotal + taxTotal).toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th>
              </tr>
            </thead>

            <tbody>
              {result && result.length > 0 ? (
                <>
                  {result.map((m, i) => (
                    <tr key={`${m.billNo || "row"}-${i}`}>
                      <td className="text-center">{i + 1}</td>
                      <td className="text-start">{m.billNo}</td>
                      <td className="text-start">
                        {m.date
                          ? new Date(m.date)
                              .toLocaleDateString("en-GB")
                              .replace(/\/\d{4}$/, (x) => "/" + x.slice(-2))
                          : ""}
                      </td>
                      <td className="text-start">{m.customerName}</td>
                      <td className="text-start">{m.hsnCode}</td>
                      <td className="text-start">{m.productName}</td>
                      <td className="text-start">{m.categoryName}</td>
                      <td>{Number(m.totalQty).toFixed(2)}</td>
                      <td>{Number(m.gstPercent).toFixed(1)}</td>
                      <td className="text-end">
                        {this.formatCurrency(m.salesAmount)}
                      </td>
                      <td className="text-end">
                        {this.formatCurrency(m.taxAmount)}
                      </td>
                      <td className="text-end">
                        {this.formatCurrency(m.salesAmount + m.taxAmount)}
                      </td>
                    </tr>
                  ))}

                  {/* ⭐ FINAL GRAND TOTAL ROW */}
                  <tr
                    style={{ fontWeight: "bold", backgroundColor: "#f3f3f3" }}
                  >
                    <td colSpan={8} className="text-end">
                      GRAND TOTAL →
                    </td>

                    {/* GST % column (blank or dash) */}
                    <td className="text-center">-</td>

                    {/* Total Sales */}
                    <td className="text-end">
                      {this.formatCurrency(salesTotal)}
                    </td>

                    {/* Total Tax */}
                    <td className="text-end">
                      {this.formatCurrency(taxTotal)}
                    </td>

                    {/* Total Invoice Value */}
                    <td className="text-end">
                      {this.formatCurrency(salesTotal + taxTotal)}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={12} className="text-center">
                    No data
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}

export class PurchaseGstReport extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      dateRange: "Today",
      result: [],
      startDate: new Date(),
      endDate: new Date(),
      loadSpinnerOpen: false,
    };
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  OnDateRangeChanged = (e) => {
    const { value } = e.target;
    this.setState({ dateRange: value, result: [] });
  };

  GetPurchaseGst = async () => {
    try {
      this.ShowLoadSpinner();

      const storeId = this.context.storeId;
      if (!storeId) {
        console.warn("StoreId not available in context");
        this.setState({ result: [] });
        return;
      }

      const url = `${
        process.env.REACT_APP_API
      }Reports/GetPurchaseGst/${storeId}/${encodeURIComponent(
        this.state.dateRange
      )}/${this.context.GetTicks(this.state.startDate)}/${this.context.GetTicks(
        this.state.endDate
      )}`;

      const resp = await fetch(url);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const data = await resp.json();

      if (!Array.isArray(data)) {
        console.warn("Expected array from server", data);
        this.setState({ result: [] });
        return;
      }

      const normalized = data.map((it) => ({
        billNo: it.billNo ?? "",
        date: it.date ?? null,
        invoiceNo: it.invoiceNo ?? "",
        supplierName: it.supplierName ?? "",
        hsnCode: it.hsnCode ?? "",
        productName: it.productName ?? "",
        totalQty: Number.isFinite(Number(it.totalQty))
          ? Number(Number(it.totalQty).toFixed(2))
          : 0,
        gstPercent: Number.isFinite(Number(it.gstPercent))
          ? Number(Number(it.gstPercent).toFixed(2))
          : 0,
        totalAmt: Number.isFinite(Number(it.totalAmt))
          ? Number(Number(it.totalAmt).toFixed(2))
          : 0,
        taxAmt: Number.isFinite(Number(it.taxAmt))
          ? Number(Number(it.taxAmt).toFixed(2))
          : 0,
        totalValue: Number.isFinite(Number(it.totalValue))
          ? Number(Number(it.totalValue).toFixed(2))
          : 0,
      }));

      // Sort by billNo. Try numeric if possible, else localeCompare numeric-aware.
      normalized.sort((a, b) => {
        // --- Sort by DATE ---
        const da = a.date ? new Date(a.date) : null;
        const db = b.date ? new Date(b.date) : null;

        // handle missing dates
        if (da && !db) return -1;
        if (!da && db) return 1;
        if (da && db) {
          const diff = da - db;
          if (diff !== 0) return diff; // if dates differ, return
        }

        // --- Secondary Sort: billNo ---
        const na = Number(a.billNo);
        const nb = Number(b.billNo);

        // Both are valid numbers → numeric compare
        if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;

        // Otherwise → string compare, numeric aware
        return String(a.billNo || "").localeCompare(
          String(b.billNo || ""),
          undefined,
          {
            numeric: true,
          }
        );
      });

      this.setState({ result: normalized });
    } catch (err) {
      console.error("GetPurchaseGst failed", err);
      this.setState({ result: [] });
    } finally {
      this.HideLoadSpinner();
    }
  };

  DownloadToCSV = () => {
    const headings =
      "#,BillNo,Date,InvoiceNo,Supplier,HSN,ProductName,TotalQty,GST%,TotalAmt,TaxAmt,TotalValue";
    let reportDetails = "Purchase (GST) Report\n";
    reportDetails += this.context.GetDateResult(
      this.state.dateRange,
      this.state.startDate,
      this.state.endDate
    );

    let rows = "";
    (this.state.result || []).forEach((m, idx) => {
      const safe = (s) => String(s ?? "").replace(/[\r\n,]+/g, " ");
      const dateStr = m.date
        ? new Date(m.date)
            .toLocaleDateString("en-GB")
            .replace(/\/\d{4}$/, (x) => "/" + x.slice(-2))
        : "";
      rows += `${idx + 1},${safe(m.billNo)},${dateStr},${safe(
        m.invoiceNo
      )},${safe(m.supplierName)},${safe(m.hsnCode)},${safe(
        m.productName
      )},${Number(m.totalQty || 0).toFixed(2)},${Number(
        m.gstPercent || 0
      ).toFixed(2)},${Number(m.totalAmt || 0).toFixed(2)},${Number(
        m.taxAmt || 0
      ).toFixed(2)},${Number(m.totalValue || 0).toFixed(2)}\n`;
    });

    const result = reportDetails + "\n\n" + headings + "\n" + rows;
    const element = document.createElement("a");
    const file = new Blob([result], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download =
      "purchase-gst-" +
      new Date().getDate() +
      (new Date().getMonth() + 1) +
      new Date().getFullYear() +
      "-" +
      new Date().getMinutes() +
      new Date().getSeconds() +
      ".csv";
    document.body.appendChild(element);
    element.click();
    element.remove();
  };

  PrintReport = () => {
    const { result, dateRange, startDate, endDate } = this.state;
    const settings = this.context.storeSettings || {};
    if (!result || result.length === 0) return;

    const storeName = settings.storeName || "";
    const storeAddress = settings.storeAddress || "";
    const storeEmail = settings.storeEmailId || "";
    const storePhone = settings.storePhoneNo || "";

    const reportTitle = "Purchase (GST) Report";
    const dateSection = this.context.GetDateResult(
      dateRange,
      startDate,
      endDate
    );

    /* ---------- helpers ---------- */
    const fmtDate = (d) => {
      if (!d) return "";
      const dt = new Date(d);
      if (isNaN(dt.getTime())) return "";
      const dd = String(dt.getDate()).padStart(2, "0");
      const mm = String(dt.getMonth() + 1).padStart(2, "0");
      const yy = String(dt.getFullYear()).slice(-2);
      return `${dd}/${mm}/${yy}`;
    };

    const num2 = (n) => Number(n || 0).toFixed(2);

    /* ---------- totals ---------- */
    const totalAmt = result.reduce((a, v) => a + Number(v.totalAmt || 0), 0);
    const totalTax = result.reduce((a, v) => a + Number(v.taxAmt || 0), 0);
    const totalValue = result.reduce(
      (a, v) => a + Number(v.totalValue || 0),
      0
    );

    /* ---------- GROUP BY BILL ---------- */
    const grouped = {};
    result.forEach((r) => {
      const key = `${r.billNo}|${r.date}|${r.supplierName}`;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(r);
    });

    /* ---------- HTML ---------- */
    let html = `
<html>
<head>
  <title>${reportTitle}</title>
  <style>
    body { font-family: Arial; padding: 20px; }
    table { width: 100%; border-collapse: collapse; margin-top: 10px; }
    th, td { border: 1px solid #888; padding: 6px; font-size: 12px; }
    th { background: #f5f5f5; }
    td { text-align: right; vertical-align: middle; }
    th.text-start, td.text-start { text-align: left; }
    .tot-row { font-weight: bold; background: #f3f3f3; }
  </style>
</head>
<body>

<div style="text-align:center">
  <div style="font-weight:bold;font-size:18px">${storeName}</div>
  <div>${storeAddress}</div>
  <div>
    ${storeEmail ? "Email: " + storeEmail : ""}
    ${storePhone ? " Phone: " + storePhone : ""}
  </div>
</div>

<h2 style="text-align:center">${reportTitle}</h2>
<h4 style="text-align:center">${dateSection}</h4>

<table>
<thead>
<tr>
  <th>No.</th>
  <th class="text-start">Bill No</th>
  <th class="text-start">Date</th>
  <th class="text-start">Supplier</th>
  <th class="text-start">HSN</th>
  <th class="text-start">Product</th>
  <th>Qty</th>
  <th>GST %</th>
  <th>Total Amt</th>
  <th>Tax Amt</th>
  <th>Total Value</th>
</tr>
</thead>
<tbody>
`;

    /* ---------- ROWS WITH ROWSPAN ---------- */
    let rowNo = 1;

    Object.values(grouped).forEach((rows) => {
      rows.forEach((m, idx) => {
        html += `<tr>`;

        // merged columns (only once per bill)
        if (idx === 0) {
          html += `
<td rowspan="${rows.length}">${rowNo++}</td>
<td rowspan="${rows.length}" class="text-start">${m.billNo || ""}</td>
<td rowspan="${rows.length}" class="text-start">${fmtDate(m.date)}</td>
<td rowspan="${rows.length}" class="text-start">${m.supplierName || ""}</td>
`;
        }

        // per-product columns
        html += `
<td class="text-start">${m.hsnCode || ""}</td>
<td class="text-start">${m.productName || ""}</td>
<td>${num2(m.totalQty)}</td>
<td>${num2(m.gstPercent)}</td>
<td>${num2(m.totalAmt)}</td>
<td>${num2(m.taxAmt)}</td>
<td>${num2(m.totalValue)}</td>
</tr>`;
      });
    });

    /* ---------- GRAND TOTAL ---------- */
    html += `
<tr class="tot-row">
  <td colspan="8" style="text-align:right">GRAND TOTAL →</td>
  <td>${num2(totalAmt)}</td>
  <td>${num2(totalTax)}</td>
  <td>${num2(totalValue)}</td>
</tr>
</tbody>
</table>

<script>
  window.onload = () => window.print();
</script>
</body>
</html>
`;

    const w = window.open("", "_blank");
    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  componentDidMount = () => {
    // this.GetPurchaseGst(); // enable auto-load if desired
  };

  onStartDateChange = (date) => this.setState({ startDate: date });
  onEndDateChange = (date) => this.setState({ endDate: date });

  formatCurrency = (value) => {
    const locale = this.context.storeSettings?.defaultLocale || "en-IN";
    const currency = this.context.storeSettings?.defaultCurrency || "INR";
    return Number(value || 0).toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      style: "currency",
      currency,
    });
  };

  render() {
    const { result } = this.state;
    const storeSettings = this.context.storeSettings || {};
    const currencyLocale = storeSettings.defaultLocale || "en-IN";

    const totalAmt = result.reduce((a, v) => a + Number(v.totalAmt || 0), 0);
    const totalTax = result.reduce((a, v) => a + Number(v.taxAmt || 0), 0);
    const totalValue = result.reduce(
      (a, v) => a + Number(v.totalValue || 0),
      0
    );

    return (
      <>
        <div>
          {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : null}

          {window.innerWidth > 900 ? (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={this.OnDateRangeChanged}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                    </Form.Select>
                  </InputGroup>
                </td>

                {this.state.dateRange === "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={this.onEndDateChange}
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : null}

                <td>
                  <Button onClick={() => this.GetPurchaseGst()}>
                    Show Report
                  </Button>
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button variant="success" onClick={this.PrintReport}>
                      🖨️ Print/PDF
                    </Button>
                  ) : null}
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button
                      variant="danger"
                      onClick={() => this.DownloadToCSV()}
                    >
                      <BiDownload size="20" /> Download(CSV)
                    </Button>
                  ) : null}
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={this.OnDateRangeChanged}
                    >
                      <option value="Custom">Custom</option>
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </InputGroup>

                  {this.state.dateRange === "Custom" ? (
                    <>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={this.onStartDateChange}
                        value={this.state.startDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                      EndDate:
                      <DateTimePicker
                        onChange={this.onEndDateChange}
                        value={this.state.endDate}
                        format="dd-MMM-yy hh:mm a"
                      />
                    </>
                  ) : null}
                </td>

                <td>
                  <Button onClick={() => this.GetPurchaseGst()}>
                    Show Report
                  </Button>
                </td>

                <td>
                  {result && result.length > 0 ? (
                    <Button
                      variant="danger"
                      onClick={() => this.DownloadToCSV()}
                    >
                      <BiDownload size="20" /> Download
                    </Button>
                  ) : null}
                </td>
              </tr>
            </>
          )}

          <Table
            bordered
            hover
            className="bg-white text-end"
            style={{
              tableLayout: "revert",
              verticalAlign: "middle",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th className="text-center">No.</th>
                <th className="text-start">Bill No</th>
                <th className="text-start">Date</th>
                {/* <th className="text-start">Invoice No</th> */}
                <th className="text-start">Supplier</th>
                <th className="text-start">HSN Code</th>
                <th className="text-start">Product Name</th>
                <th>Total Qty</th>
                <th>GST %</th>
                <th>
                  Total Purchase Amt
                  <br />[
                  {result && result.length > 0
                    ? totalAmt.toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th>
                <th>
                  Tax Amt
                  <br />[
                  {result && result.length > 0
                    ? totalTax.toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th>
                <th>
                  Total Value
                  <br />[
                  {result && result.length > 0
                    ? totalValue.toLocaleString(currencyLocale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })
                    : this.formatCurrency(0)}
                  ]
                </th>
              </tr>
            </thead>

            <tbody>
              {result && result.length > 0 ? (
                <>
                  {result.map((m, i) => (
                    <tr key={`${m.billNo || "row"}-${i}`}>
                      <td className="text-center">{i + 1}</td>
                      <td className="text-start">{m.billNo}</td>
                      <td className="text-start">
                        {m.date
                          ? new Date(m.date)
                              .toLocaleDateString("en-GB")
                              .replace(/\/\d{4}$/, (x) => "/" + x.slice(-2))
                          : ""}
                      </td>
                      {/* <td className="text-start">{m.invoiceNo}</td> */}
                      <td className="text-start">{m.supplierName}</td>
                      <td className="text-start">{m.hsnCode}</td>
                      <td className="text-start">{m.productName}</td>
                      <td>{Number(m.totalQty).toFixed(2)}</td>
                      <td>{Number(m.gstPercent).toFixed(2)}</td>
                      <td className="text-end">
                        {this.formatCurrency(m.totalAmt)}
                      </td>
                      <td className="text-end">
                        {this.formatCurrency(m.taxAmt)}
                      </td>
                      <td className="text-end">
                        {this.formatCurrency(m.totalValue)}
                      </td>
                    </tr>
                  ))}

                  {/* GRAND TOTAL */}
                  <tr
                    style={{ fontWeight: "bold", backgroundColor: "#f3f3f3" }}
                  >
                    <td colSpan={8} className="text-end">
                      GRAND TOTAL →
                    </td>
                    <td className="text-end">
                      {this.formatCurrency(totalAmt)}
                    </td>
                    <td className="text-end">
                      {this.formatCurrency(totalTax)}
                    </td>
                    <td className="text-end">
                      {this.formatCurrency(totalValue)}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={11} className="text-center">
                    No data
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}
